import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Filter,
  ReferenceInput,
  SelectInput,
} from "react-admin";

import { ListPagination } from "../../../utils";

const NfeSampleUploadFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      perPage={999}
      resource="lab"
      label="Laboratório"
      source="lab_id"
      reference="labs"
      alwaysOn
    >
      <SelectInput label="Laboratório" optionText="name" optionValue="id"/>
    </ReferenceInput>
  </Filter>
);


const NfeSampleUploadList = (props) => (
  <List
    {...props}
    sort={{ field: "createdAt", order: "DESC" }}
    perPage={25}
    pagination={<ListPagination />}
    empty={false}
    exporter={false}
    bulkActionButtons={false}
    title="Lista dos Envios"
    filters={<NfeSampleUploadFilter />}
  >
    <Datagrid>
      <TextField source="lab.name" label="Laboratório" />
      <TextField source="samplesUpdated" label="Amostras Atualizadas" />
      <DateField
        source="createdAt"
        label="Data de criação"
        locales="pt-BR"
        options={{ year: "numeric", month: "2-digit", day: "2-digit" }}
        emptyText="-"
      />
    </Datagrid>
  </List>
);

export default NfeSampleUploadList;
